(function() {
  'use strict';
  angular.module('benefits')
  .controller('dashboardController', ['$stateParams', 'Members', 'benefitService', '$scope', '$location', '$state','$q','$filter', 'printService','$uibModal',
	  								  'secSecurityService','pdfPrintUtility','uuid','$window','printBenefitsHelper',
    function($stateParams, Members, benefitService, $scope, $location, $state,$q,$filter, printService, $uibModal,
    								  securityService,printUtility,angularUUID,$window,printHelper) {
      var vm = this;
    this.refId = $stateParams.referenceId;
    vm.copayScheduleParams = {};
    vm.copaySchedule = undefined;
    vm.printReady = false;
    vm.isDentalHmo = false;
    vm.dmoProvider = undefined;
    benefitService.clearDashboardState();
    printHelper.initPrintables();
    this.$location = $location;
    this.expandAssociatedMembers = $stateParams.expandAssociatedMembers === 'true';
    vm.scrollbarWidth = undefined;
    $scope.$watch('vm.scrollbarWidth',function(n,o) {
    	vm.reposRightNav(n,o);
    });
    if($stateParams.eligibilityAuditTS != null && $stateParams.eligibilityAuditTS !== undefined){
      	//console.log(">>> dashboardController referenceId: " + $stateParams.referenceId +" uuid: "+$stateParams.uuid+" eligibilityAuditTS "+$stateParams.eligibilityAuditTS);
        this.uuid=$stateParams.uuid;
      	var mpDefer = $q.defer();
      	var psmDefer = $q.defer();
      	var papDefer = $q.defer();
      	var bIPDefer = $q.defer();
      	var phPdefer = $q.defer();
      	benefitService.associatedMembersPromise =mpDefer.promise;
      	benefitService.planSummaryPromise = psmDefer.promise;
      	benefitService.planAccumPromise = papDefer.promise;
      	benefitService.benefitInfoPromise = bIPDefer.promise;
      	benefitService.procedureHistoryPromise = phPdefer.promise;

      	this.showHistoryMessage = true;
      	this.eligibilityAuditTS = getTimestamp($stateParams.eligibilityAuditTS);
      	Members.getEligibilityHistory($stateParams).$promise.then(function(data) {
      		mpDefer.resolve(data.associatedMembers);
      		psmDefer.resolve(data.planSummary);
      		papDefer.resolve(data.planAccumulators);
      		bIPDefer.resolve(data.benefits);
      		phPdefer.resolve(data.procedureHistory);
      		//console.log(">>> if dashboardController "+JSON.stringify(data.procedureHistory));
      	});

      }  else {
       //console.log(">>> else dashboardController ");
       this.showHistoryMessage = false;
       benefitService.associatedMembersPromise = Members.associatedMembers($stateParams).$promise.then((res) => {
       if (res.serviceUnavailable) {
        return Members.query($stateParams).$promise.then((memberLookupResult) => {
          let member = _.find(memberLookupResult.data, (member) => {
            if (!member) {
              return;
            }
            return _.filter(member.policies, (p) => {
              return p.referenceId === $stateParams.referenceId;
            }).length;
          });
          if (!member) {
            showError();

            return [];
          }
          member.policies = _.filter(member.policies, (p) => {
            return p.referenceId === $stateParams.referenceId;
          });
          let members = [member];
          members.serviceUnavailable = true;
          return members;
        }, showError);
      } else {
        return res.data;
      }
    });
    $stateParams.uuid= angularUUID.v4();
    this.uuid=$stateParams.uuid;

	var planSummaryDefer = $q.defer();
	benefitService.planSummaryPromise = planSummaryDefer.promise;

    securityService.getUserHome().then(function (userHome) {
    	if(userHome != 'lookup'){
    		$stateParams.uuid= null; //store UUID only for Provider
    	}
    	planSummaryDefer.resolve(Members.planSummary($stateParams).$promise);

    });
    benefitService.planAccumPromise = Members.planAccum($stateParams).$promise;

    benefitService.benefitInfoPromise = Members.benefitInfo($stateParams).$promise;

    benefitService.procedureHistoryPromise = Members.procedureHistory({referenceId: $stateParams.referenceId}).$promise;

    var arrayOfPromises = [benefitService.associatedMembersPromise ,benefitService.planSummaryPromise, benefitService.planAccumPromise, benefitService.benefitInfoPromise,  benefitService.procedureHistoryPromise];
    //$q A service that helps you run functions asynchronously, and use their return values (or exceptions) when they are done processing.
    $q.all(arrayOfPromises).then(function(data) {
      vm.benefitData = data;
      return benefitService.getPolicyByRefId(vm.refId).then(function(policy) {
        vm.dmoProvider = policy ? policy.dmoProvider : undefined;
        vm.isDentalHmo = benefitService.hasDentalHmoPolicy(policy);
        benefitService.setIsDentalHmo(vm.isDentalHmo);
        if (!vm.isDentalHmo) {
          benefitService.copaySchedulePromise = undefined;
          vm.copaySchedule = undefined;
          return data;
        }
        return benefitService.getCopayScheduleParams(vm.refId).then(function(params) {
          vm.copayScheduleParams = params;
          vm.clientCode = params.clientCode;
          vm.planCode = params.planCode;
          benefitService.copaySchedulePromise = Members.copaySchedule(params).$promise;
          return benefitService.copaySchedulePromise.then(function(copaySchedule) {
            vm.copaySchedule = copaySchedule;
            return data;
          });
        });
      });
    }).then(function(data) {
      vm.printReady = true;
      securityService.getUserHome().then(function (userHome) {
        if(userHome == 'lookup' && $stateParams.subscriberId != null){
          Members.saveEligibilityHistory($stateParams,data).$promise;
    	}
      });
     });
    }

    function getTimestamp(date) {
        let d = new Date(date).getTime();
        let tzOffset = new Date().getTimezoneOffset() * 60 * 1000;
        return $filter('date')(d - tzOffset, 'M/d/yy h:mm a');
    }
    function showError() {
        $scope.$watch('dnConfirmationMessage', (dnConfirmationMessage) => {
          dnConfirmationMessage &&
            dnConfirmationMessage.$show('Information about this member could not be retrieved at this time.  Please try again later.',
            'warning').then(() => {
              $state.go('lookup');
            });
        });
      }
    $scope.scrollTo = function (id) {
        $location.hash(id);
    };

    vm.print = function() {
        if (vm.isDentalHmo) {
          return;
        }
        var modalInstance = $uibModal.open({
          templateUrl: '/js/benefits/printModal.html' + appVersion,
          controllerAs:'vm',
          controller: 'printModalController',
          size: 'lg',
          animation: false,
          resolve: {
              benefitInfoData : function() { 
                   return vm.benefitData[3]
              }
          }
        });
        modalInstance.result.then(function(printables) {

          var printInfo = {};
          var printBenefits  = false;
          _.each(printables.sections, function(section) {
            if (section.checked && section.printableObjName && section.id) {
                switch (section.id) {
                  case 'planInfoSection': printInfo[section.printableObjName] = printUtility.getPrintableTable(section.id)['PlanInfoSection']; break;
                  case 'serviceValueStatement':  printInfo[section.printableObjName] = printUtility.getPrintableTextByIds(section.id)['ServiceValueStatement'];break;
                  case 'procedureHistory': 
                	  		let procedureHistory = printUtility.getPrintableUiGrid('grid')['Grid'];
                	  		if (procedureHistory) { 
                	  			printInfo[section.printableObjName] = procedureHistory; 
                	  		}
                	  		break;
                  default: printInfo[section.printableObjName] = printUtility.getPrintableSection(section.id);
                }
                printBenefits = true;
            }
		      });
          if (printBenefits && printables.procedureCodes && printables.procedureCodes.length > 0) {
            printInfo.procedureCodes = [];
            _.each(printables.procedureCodes, function(procedureCode) {
              if (procedureCode.checked && procedureCode.printableObjName && procedureCode.id) {
                printInfo.procedureCodes.push({'Code': procedureCode.id, 'Details': printHelper.printableProcedureCodes(procedureCode.id)});
              }
            });
          }
          if(printBenefits && printables.benefitCategories && printables.benefitCategories.length > 0){
              printInfo.benefitInfo = {}
              printInfo.benefitInfo = printUtility.getPrintableTextByIds(['professionalReview','dentalnetWarning']);
              let cateHeading = getCategoryFieldNames();
              
              printInfo.benefitInfo.categories = [];
              _.each(printables.benefitCategories, function(beneCate) {
                  if (beneCate.checked && beneCate.printableObjName && beneCate.id) {
                      let cateValues = printUtility.getPrintableAccordion('accorDiv','Cate'+beneCate.printIndex ,cateHeading);
                      let details = null;
                      if(beneCate.detailsChecked && (vm.benefitData[3].categories[beneCate.printIndex].toggleClass != "hidden")){
                    	  let accumulatorInfo = printUtility.getPrintableTable('accumulator'+beneCate.printIndex)['Accumulator' + beneCate.printIndex];
                    	  details = _.merge({},
                                  printUtility.getPrintableDescriptionList('Cate'+beneCate.printIndex),
                                  accumulatorInfo ? {'AccumulatorInfo': accumulatorInfo } : {}
                                 ); 
                      }
                    printInfo.benefitInfo.categories.push({'CategoryName': beneCate.id, 
                    									   'CategorySummary': cateValues.AccorDiv, 
                    									   'CategoryDetails': details 
                    									 });
                  }
               });
              if(printInfo.benefitInfo.categories.length > 0){
        		  let beneCate = vm.benefitData[3].categories[0];
                  if(beneCate){
                      if(beneCate.copayClass == 'hidden'){
                          printInfo.benefitInfo.CopayInd = 0;
                      }else{
                          printInfo.benefitInfo.CopayInd = 1;
                      }
                      if(beneCate.planType){
                          printInfo.benefitInfo.PlanType = beneCate.planType;
                      }
                  }
              }
          }
          if (printBenefits) {
            printInfo.printType = "benefits";
            vm.printing = true;
            printService.print(printInfo,function(pdfdata) {
              vm.printing = false;              
              if (pdfdata.serviceUnavailable) {
            	  $scope.dnConfirmationMessage.$show('Printing Service is currently not available.  Please try again later.', 'danger');
              }else{
	              if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
	          	     $window.navigator.msSaveOrOpenBlob(pdfdata.document);
	          	   }else {
	          	      var printUrl = URL.createObjectURL(pdfdata.document);
	          	       $window.open(printUrl, 'dnoa');
	          	   }
              }
              },function (error) {
                  vm.printing = false;
                  $scope.dnConfirmationMessage.$show('Error while generating document', 'warning');
              });
          }
        }, function() {

        });

    };

    vm.setScrollbarWidth = function(event) {
    	var mainP = document.getElementById('benefitsMainPanel');
    	if (mainP) {
	    	var scrollbarWidth = mainP.offsetWidth - mainP.clientWidth;
	        vm.scrollbarWidth = isNaN(scrollbarWidth) ? 0 : scrollbarWidth ;
    	}else{
    		vm.scrollbarWidth = undefined;
    	}
    };

    vm.reposRightNav =  function(newWidth, currWidth) {
    	if (!(isNaN(newWidth))) {
           var widthDiff = newWidth - (isNaN(currWidth) ? 0 : currWidth);
  	       if (widthDiff != 0) {
  		       var boxes = document.querySelectorAll(".surveyMonkeyBox,#rightSideNav");
  		        _.each(boxes, function(box) {
  		          var currPos = $window.getComputedStyle(box,null).getPropertyValue('right');
  		          currPos = parseInt(currPos, 10);
  		          box.style.right = ((isNaN(currPos) ? 0 : currPos) + widthDiff) + 'px';
  		        });
  	      }
    	}
   };
   $window.addEventListener('resize',vm.setScrollbarWidth, true);
   document.addEventListener('load',vm.setScrollbarWidth, true);
   
   function getCategoryFieldNames(){
	   let cateHeading =[{"name" : "CategoryName"},{"name" : "InNetworkPercent"},{"name" : "InNetworkDeductibleMetPercent"},{"name" : "OutNetworkPercent"},{"name" : "OutNetworkDeductibleMetPercent"},{"name" : "CopayAmount"},{"name" : "CoinsuranceDeductibleMetPercent"},
       {"name" : "AgeLimitationWarning"},{"name" : "OutNetworkNotCoveredText"},{"name" : "InNetworkNotCoveredText"},{"name" : "FrequencyLimitationText"},{"name" : "NotInPlanText"},{"name" : "NotCoveredInOutText"},{"name" : "LastDateOfService"},{"name" : "CoinsurancePercent"},
       {"name" : "CoinsurancePercent"},{"name" : "CoinsuranceDeductibleMetPercent"},{"name" : "CoinsuranceNotCoveredText"}];
       
       return cateHeading;
	   
   }


  }]);
})();
